module.exports = __webpack_public_path__ + "img/fopea-VacaMuerta.f4b8f8eb.jpg";